export const UniversityName: string = 'Faculdade Santo André';

export const MobileResolution: string = '750px';
